import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
import { selectData } from "../../../services/store/userSlice";
// import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

import { capitalize } from "../../../services/utility/helper";
import { leaveService } from "../../../services/extensions";
import { LeaveStatus } from "../../../common/util/constants";
import { utitService } from "../../../services/util";

import { Util } from "../../../services";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { ViewLeave } from "./view-leave";
import DateColumn from "../components/DateColumn";

const Draft = ({ leaves, reload }) => {
  const userData = useSelector(selectData);
  const { user } = useSelector((state) => state.user);
  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const [editingRows, setEditingRows] = useState({});
  const [selLeaves, setSelLeaves] = useState({});
  const [viewDialog, setViewDialog] = useState(false);
  const [viewTabIndex, setViewTabIndex] = useState(0);
  const [region, setRegion] = useState("ESIN");

  useEffect(() => {
    if (user) {
      const leCode = user?.LegalEntity?.code || "ESIN";
      setRegion(leCode);
    }
  }, [user]);

  useEffect(() => {
    // console.table("Draft", [leaves]);
  }, [leaves]);
  const deleteById = (id) => {
    leaveService.deleteLeaveById(id).then(
      (resp) => {
        toast.info("Leave Record deleted..");
        reload();
      },
      (error) => {
        const msg = error?.response?.data?.error;
        toast.error(msg ? msg : "Unable to delete leave record");
      },
    );
  };

  const deleteLeave = (e, row) => {
    confirmDialog({
      // target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => deleteById(row.id),
      accept: () => {},
    });
  };

  const deleteMultipleLeaves = (e) => {
    confirmDialog({
      // target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: delAllLeaves,
      accept: () => {},
    });
  };

  const delAllLeaves = () => {
    if (selectedLeaves.length > 0) {
      const idList = selectedLeaves.map((item) => item.id); // Simplified mapping
      let param = { Ids: idList };
      leaveService
        .deleteAllLeaves(param)
        .then((resp) => {
          toast.info("Leaves Record deleted..");
          reload();
        })
        .catch((error) => {
          const msg = error?.response?.data?.error;
          toast.error(msg ? msg : "Unable to delete leave record");
        });
    }
  };

  //submit leave to review
  const submitLeaves = () => {
    const leaveIds = selectedLeaves?.map((leave) => leave.id) || [];
    const currentUser = JSON.parse(localStorage.getItem("user"));
    if (leaveIds.length > 0) {
      let payload = { Ids: leaveIds };
      leaveService.updateMultipleLeave(payload).then((resp) => {
        toast.success(
          "Your leaves have been shared with " +
            capitalize(currentUser.superior.firstName) +
            " " +
            capitalize(currentUser.superior.lastName) +
            " for approval",
        );
        setSelectedLeaves([]);
        reload();
      });
    }
  };

  const updateLeave = (id, data) => {
    const ac = userData?.userAbsenceCodes?.find(
      (x) => x.title == data.absenceCode || x.code == data.absenceCode,
    );
    const at = userData?.userLeaveType?.find(
      (x) => x.title == data.leaveType || x.code == data.leaveType,
    );
    let payload = {
      id: id,
      startDate: Util.dateConverterForLeave(data.startDate),
      endDate: Util.dateConverterForLeave(data.endDate),
      absenceCode: ac.code, // ac.code,
      leaveType: at.code,
      reasonOfLeave: data.reasonOfLeave,
      // status: _leaves[index].status ? 1 : 0,
    };
    leaveService
      .updateDraftLeaveById(payload)
      .then((resp) => {
        if (resp) {
          toast.success("Leave Record Updated");
          reload();
          setEditingRows({});
          setSelectedLeaves([]);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error);
      });
  };

  const onUpdate = (e, row, op) => {
    const key = Object.keys(editingRows);
    const data = editingRows[key];
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to update this leave data?",
      header: "Update Confirmation",
      icon: "pi pi-question-triangle",
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => updateLeave(row.id, data),
      reject: () => {},
    });
  };

  const renderActions = (rowData, options) => {
    return (
      <div className="action-column">
        {editingRows[rowData.id] ? (
          <>
            <Button
              icon="pi pi-check"
              className="p-button-rounded p-button-text p-button-success"
              aria-label="Update"
              onClick={(e) => onUpdate(e, rowData, options)}
            />
            <Button
              icon="pi pi-times"
              className="p-button-rounded p-button-text p-button-danger"
              aria-label="Cancel"
              onClick={() => setEditingRows({})}
            />
          </>
        ) : (
          <>
            {/* {rowData.attachment !== null && <Button icon="pi pi-link" className="p-button-rounded p-button-text p-button-warning" aria-label="Document" onClick={() => viewLeave(rowData, 1)} />} */}
            <Button
              icon="pi pi-eye"
              className="p-button-rounded p-button-text p-button-info"
              aria-label="View"
              onClick={(e) => viewLeave(e, rowData, 0)}
            />
            <Button
              icon="pi pi-pencil"
              className="p-button-rounded p-button-text"
              aria-label="Edit"
              onClick={() => {
                setEditingRows({ [rowData.id]: rowData });
              }}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-text p-button-danger"
              aria-label="Delete"
              onClick={(e) => deleteLeave(e, rowData)}
            />
          </>
        )}
      </div>
    );
  };
  const renderAbsenceCode = (rowData, options) => {
    const ac = userData?.userAbsenceCodes?.find(
      (x) => x.title == rowData.absenceCode || x.code == rowData.absenceCode,
    );
    return (
      <>
        <strong>{ac?.code}</strong>
        <em> ({userData?.absenceCode[ac?.code]?.title})</em>
        <span className="ml-2" style={{ color: "#d6be39" }}>
          {rowData.attachment !== null && <i className="pi pi-link" />}
        </span>
      </>
    );
  };
  const renderAbsenceDuration = (rowData, options) => {
    return (
      <>
        {userData && userData.leaveCode && (
          <>
            <strong>{rowData.leaveType}</strong>
            {userData.leaveCode && (
              <em> ({userData?.leaveCode[rowData.leaveType]?.title})</em>
            )}
          </>
        )}
      </>
    );
  };
  const renderReasonOfLeave = (rowData, options) => {
    const reason = rowData.reasonOfLeave || "";
    const txt = reason.substr(0, 200);
    return (
      <>
        <span className="noet">{txt}</span>
      </>
    );
  };

  const renderLeaveHours = (rowData) => {
    if (!rowData.leaveHours || rowData.leaveHours <= 0) return "-";
    return <strong>{rowData.leaveHours}</strong>;
  };

  const onChangeValue = (v, k) => {
    const [key] = Object.keys(editingRows);
    const obj = editingRows[key];
    obj[k] = v;
    setEditingRows({ ...editingRows });
  };

  const absenceCodeEditor = (options) => {
    const v = userData?.userAbsenceCodes?.find(
      (x) => x.code === options.value || x.title === options.value,
    );
    return (
      <>
        <Dropdown
          className="w100"
          value={v?.title}
          options={userData?.userAbsenceCodes}
          optionLabel="label"
          optionValue="title"
          onChange={(e) => {
            options.editorCallback(e.value);
            onChangeValue(e.target.value, "absenceCode");
          }}
          placeholder="Select Absence Code"
        />
      </>
    );
  };

  const leaveTypeEditor = (options) => {
    const absCode = options.rowData.absenceCode;
    const v = userData?.userLeaveType.find(
      (x) => x.code === options.value || x.title === options.value,
    );
    let leaveTypeOptions = [];
    try {
      if (userData) {
        if (
          ["ML", "PL", "BL", "RH", "LWP", "ADL", "PBL", "PAL", "SSL"].includes(
            absCode,
          )
        ) {
          leaveTypeOptions = userData?.userLeaveType.filter(
            (x) => x.code !== "HD",
          );
        } else {
          leaveTypeOptions = userData?.userLeaveType;
        }
      }
    } catch (error) {
      console.log("Error on listing", error);
    }
    return (
      <Dropdown
        className="w100"
        value={v?.title}
        options={leaveTypeOptions}
        optionLabel="label"
        optionValue="title"
        onChange={(e) => {
          options.editorCallback(e.value);
          onChangeValue(e.target.value, "leaveType");
        }}
        placeholder="Select leave type"
      />
    );
  };

  const reasonEditor = (options) => {
    return (
      <InputText
        className="w100"
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.value);
          onChangeValue(e.target.value, "reasonOfLeave");
        }}
        placeholder="Enter leave reason"
      />
    );
  };

  const viewLeave = (e, row, tabIndex = 0) => {
    setSelLeaves(row);
    setViewDialog(true);
    setViewTabIndex(tabIndex);
  };

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        {/* <img alt={data.representative.name} src={`images/avatar/${data.representative.image}`} onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} width="32" style={{ verticalAlign: 'middle' }} /> */}
        <span className="image-text">{data.sandwichId}</span>
      </React.Fragment>
    );
  };
  const onRowSelection = (e, o) => {
    const selectedItems = e.value || [];
    setSelectedLeaves(e.value);
    // selectedItems.map(item => {
    //     if (item.sandwichId) {
    //         const filteredLeaves = leaves.filter(x => x.sandwichId === item.sandwichId);
    //         const selectedFilteredLeves = selectedItems.filter(x => x.sandwichId === item.sandwichId);
    //         if (selectedFilteredLeves.length === 1) {
    //             const clubedRestItem = filteredLeaves.filter(x => x.id !== item.id);
    //             setSelectedLeaves([...selectedItems, ...clubedRestItem]);
    //         } else {
    //             if (selectedFilteredLeves.length > 1 && selectedFilteredLeves.length < filteredLeaves.length) {
    //                 const clubedRestItem = selectedItems.filter(x => x.sandwichId !== item.sandwichId);
    //                 setSelectedLeaves([...clubedRestItem]);
    //             }
    //         }
    //     }
    // });
  };

  const rowClass = (data) => {
    return {
      "ess-clubed": data.sandwichId !== null,
    };
  };

  return (
    <div>
      {ViewLeave({
        visible: viewDialog,
        onHide: () => setViewDialog(false),
        style: { width: "900px" },
        leave: selLeaves,
        header: "Leave Details",
        tabIndex: viewTabIndex,
      })}
      <DataTable
        value={leaves}
        responsiveLayout="scroll"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        selection={selectedLeaves}
        onSelectionChange={onRowSelection}
        selectionMode="multiple"
        editMode="row"
        editingRows={editingRows}
        dataKey="id"
        onRowEditInit={(e) => {
          console.log("Row edit initiated");
        }}
        onRowEditChange={(e) => {
          console.log("Row edit change");
        }}
        rowClassName={rowClass}
      >
        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
        <Column
          field="startDate"
          header="Start Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        <Column
          field="endDate"
          header="End Date"
          headerStyle={{ width: "130px" }}
          body={DateColumn}
        />
        {/* <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} /> */}

        {region === "ESAU" && (
          <Column
            field="leaveHours"
            header="Hours"
            headerStyle={{ width: "100px" }}
            body={renderLeaveHours}
          />
        )}
        <Column
          field="absenceCode"
          header="Absence Code"
          headerStyle={{ width: "220px" }}
          body={renderAbsenceCode}
          // editor={(options) => absenceCodeEditor(options)}
        />
        <Column
          field="leaveType"
          header="Leave Type"
          headerStyle={{ width: "180px" }}
          body={renderAbsenceDuration}
          editor={(options) => leaveTypeEditor(options)}
        />
        <Column
          field="reasonOfLeave"
          header="Reason of leave"
          body={renderReasonOfLeave}
          editor={(options) => reasonEditor(options)}
        />
        <Column
          header="Actions"
          headerClassName="center-header"
          headerStyle={{ width: "125px", textAlign: "center" }}
          bodyStyle={{ textAlign: "right" }}
          body={renderActions}
        />
      </DataTable>
      <div className="field col flex p-0 m-0 mt-3">
        <Button
          label="Submit All"
          className="p-button-primary mr-2"
          icon="pi pi-check"
          onClick={submitLeaves}
          disabled={selectedLeaves?.length === 0}
        />
        <Button
          label="Delete All"
          className="p-button-danger"
          icon="pi pi-trash"
          onClick={deleteMultipleLeaves}
          disabled={selectedLeaves?.length === 0}
        />
      </div>
    </div>
  );
};
export default Draft;
